const Request = require('./BaseRequest')
const WebinarGraph = require('../graph/WebinarGraph')

module.exports = class WebinarRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new WebinarGraph(this.apiDomain)
    }

    async webinarRegister(optional={registrant_from: ""})
    {
        let args = { ...optional }
        let { type, query } = this.graph.webinarRegister(['id', 'webinar_event_id', 'first_name', 'last_name', 'email', 'registrant_from'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    async event(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.eventQuery(['id', 'title', 'date', 'image', 'thumbnail', 'url', 'publish_start_date', 'publish_timezone', 'publish_end_date'])
        let data = await this.graph.request(query, args, type)
        console.log('data-',data)
        return data
    }

    async events(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.eventsQuery(['id', 'title', 'date', 'image', 'thumbnail', 'url', 'publish_start_date', 'publish_timezone', 'publish_end_date'])
        let data = await this.graph.request(query, args, type)
        console.log('data-',data)
        return data
    }

    swrEvent(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.eventQuery(['id', 'title', 'date', 'image', 'thumbnail', 'url', 'publish_start_date', 'publish_timezone', 'publish_end_date'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrEvents(optional={ sort: "DATE_DESC", limit: 8 })
    {
        let args = {...optional}
        let { type, query } = this.graph.eventsQuery(['id', 'title', 'date', 'image', 'thumbnail', 'url', 'publish_start_date', 'publish_timezone', 'publish_end_date'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}